<script setup>
import { useCustomFields } from '@/composables/useCustomFields'
const { renderer } = useCustomFields()

defineProps({
    project: {
        type: Object,
        required: true
    },
    building: {
        type: Object,
        required: true
    },
    buildingThumbnail: {
        type: String,
        required: true
    },
    buildingStatistics: {
        type: Function,
        required: true
    },
    minimumWidth: {
        type: [Number, String],
        default: 180
    }
})
</script>
<template>
    <v-card class="mx-auto building-card" :min-width="minimumWidth">
        <img :src="buildingThumbnail" :alt="building.name" class="building-thumbnail" />
        <v-card-text>
            <div class="text-subtitle-1 building-name" :title="building.name">
                {{ building.name }}
            </div>
            <ul class="stats-list">
                <li>
                    <span class="font-weight-bold text-capitalize"> {{ $t('available') }}: </span>
                    <span class="ml-1">
                        {{ buildingStatistics(building.id).availableUnits }}
                        /
                        {{ buildingStatistics(building.id).totalUnits }}
                    </span>
                </li>
                <li>
                    <span class="font-weight-bold text-capitalize"> {{ $t('price') }}: </span>
                    <span class="ml-1">
                        {{
                            renderer(
                                project,
                                'currency',
                                'price',
                                buildingStatistics(building.id).minimumPrice
                            )
                        }}
                        -
                        {{
                            renderer(
                                project,
                                'currency',
                                'price',
                                buildingStatistics(building.id).maximumPrice
                            )
                        }}
                    </span>
                </li>
                <li>
                    <span class="font-weight-bold text-capitalize"> {{ $t('area') }}: </span>
                    <span class="ml-1">
                        {{
                            renderer(
                                project,
                                'number',
                                'size',
                                buildingStatistics(building.id).minimumSize
                            )
                        }}
                        -
                        {{
                            renderer(
                                project,
                                'number',
                                'size',
                                buildingStatistics(building.id).maximumSize
                            )
                        }}
                    </span>
                </li>
                <li>
                    <span class="font-weight-bold text-capitalize"> {{ $t('room') }}: </span>
                    <span class="ml-1">
                        {{
                            renderer(
                                project,
                                'number',
                                'rooms',
                                buildingStatistics(building.id).minimumRooms
                            )
                        }}
                        -
                        {{
                            renderer(
                                project,
                                'number',
                                'rooms',
                                buildingStatistics(building.id).maximumRooms
                            )
                        }}
                    </span>
                </li>
            </ul>
            <slot></slot>
        </v-card-text>
    </v-card>
</template>
<style scoped>
.stats-list li span {
    font-size: 0.7rem;
}

.building-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.building-thumbnail {
    max-width: 100%;
    width: 400px;
    height: auto;
}
</style>
